const isNaNReturnDefault = (field: number, defaultValue: number = 0) => {
  return !isNaN(field) ? field : defaultValue;
};

export default isNaNReturnDefault;
